import {
  HOME,
  MPPI,
  LANDLORDS,
  TENANTS_CONTENTS,
  TENANTS_LIABILITY,
} from "@/constants/questionset.constants";

export const qsMapping = {
  [HOME]: {
    hpr: {
      questions: () => import("@/qs/home/hpr/questions.json"),
      application: () => import("@/qs/home/hpr/application.json"),
    },
    d2c: {
      questions: () => import("@/qs/home/d2c/questions.json"),
      application: () => import("@/qs/home/d2c/application.json"),
    },
    hpr_advised: {
      application: () => import("@/qs/home/hpr_advised/application.json"),
    },
    hpr_d2c: {
      questions: () => import("@/qs/home/hpr_d2c/questions.json"),
      application: () => import("@/qs/home/hpr_d2c/application.json"),
    },
    rqs: {
      questions: () => import("@/qs/home/rqs/questions.json"),
      application: () => import("@/qs/home/rqs/application.json"),
    },
    rqs_advised: {
      application: () => import("@/qs/home/rqs_advised/application.json"),
    },
  },
  [LANDLORDS]: {
    d2c: {
      questions: () => import("@/qs/landlords/d2c/questions.json"),
      application: () => import("@/qs/landlords/d2c/application.json"),
    },
    rqs: {
      questions: () => import("@/qs/landlords/rqs/questions.json"),
      application: () => import("@/qs/landlords/rqs/application.json"),
    },
  },
  [TENANTS_CONTENTS]: {
    rqs: {
      questions: () => import("@/qs/tenants_contents/rqs/questions.json"),
      application: () => import("@/qs/tenants_contents/rqs/application.json"),
    },
    rqs_advised: {
      questions: () =>
        import("@/qs/tenants_contents/rqs_advised/questions.json"),
      application: () =>
        import("@/qs/tenants_contents/rqs_advised/application.json"),
    },
  },
  [TENANTS_LIABILITY]: {
    rqs: {
      questions: () => import("@/qs/tenants_liability/rqs/questions.json"),
      application: () => import("@/qs/tenants_liability/rqs/application.json"),
    },
  },
  [MPPI]: {
    rqs: {
      questions: () => import("@/qs/mppi/rqs/questions.json"),
      application: () => import("@/qs/mppi/rqs/application.json"),
    },
  },
};
